<template>
    <section class="inner-content table-header">
        <h1 class="is-flex is-justify-content-space-between">
            <span class="title is-uppercase"><slot></slot></span>

            <b-field>
                <slot name="buttons"></slot>
            </b-field>
        </h1>
    </section>
</template>
<script>
    export default {
    }
</script>